import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import useTimeout from '@clearscore/hooks.use-timeout';
import Portal from '@clearscore/helpers.portal';
import Text from '@clearscore/rainbow.text';

import styles from './notification.controller.css';
import { themes } from '../constants';
import Notification from '../notification';

const NotificationController = ({ dataId, isOpen, children, onDismiss, duration, ...props }) => {
    const [render, setRender] = useState(false);
    useEffect(() => {
        let timer;

        isOpen ? setRender(true) : (timer = setTimeout(() => setRender(false), 100));

        return () => clearTimeout(timer);
    }, [isOpen, setRender]);
    useTimeout(onDismiss, duration);

    return (
        <Portal className={styles.containerWrapper}>
            <div
                className={cx({ [styles.enter]: isOpen, [styles.exit]: !isOpen })}
                data-qa="notification-controller"
                data-id={dataId}
            >
                {render && (
                    <Notification {...{ ...props, onDismiss }}>
                        <Text.Body2>{children}</Text.Body2>
                    </Notification>
                )}
            </div>
        </Portal>
    );
};

NotificationController.propTypes = {
    duration: PropTypes.number,
    isOpen: PropTypes.bool,
    dataId: PropTypes.string,
    children: PropTypes.node,
    theme: PropTypes.oneOf(Object.values(themes)),
    title: PropTypes.string,
    ctaText: PropTypes.string,
    ctaHandler: PropTypes.func,
    onDismiss: PropTypes.func,
};

NotificationController.defaultProps = {
    duration: null,
    isOpen: false,
    dataId: '',
    children: null,
    theme: themes.INFO,
    ctaText: '',
    ctaHandler: null,
    title: '',
    onDismiss: undefined,
};

export default NotificationController;
